import { render, staticRenderFns } from "./ActivityGroup.vue?vue&type=template&id=55020410&scoped=true&"
import script from "./ActivityGroup.vue?vue&type=script&lang=js&"
export * from "./ActivityGroup.vue?vue&type=script&lang=js&"
import style0 from "./ActivityGroup.vue?vue&type=style&index=0&id=55020410&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55020410",
  null
  
)

export default component.exports